import React from 'react';
import { Horoscope } from 'lib/types/replay';

export interface Slide7Props {
  horoscope: Horoscope;
}

/** Slide 7 - Horoscope */
export const Slide07 = ({
  horoscope,
}: Slide7Props) => (
  <div className="absolute inset-0 h-full w-full text-white items-center font-light">
    <div className="absolute top-[25%] ">
      <div className="px-11 pt-8 text-4xl font-normal text-center animate-fadein">{horoscope.name}</div>
      <img src={horoscope.imageUrl} alt={horoscope.name} className="m-auto py-2 animate-zoomin" width="75%" />
      <div className="px-11 text-m text-left animate-fadein">
        {horoscope?.text}
      </div>
    </div>
  </div>
);
